export const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <g clipPath="url(#clip0_5200_13573)">
      <path d="M4.5 6H11.5" stroke="#151515" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.5 9H11.5" stroke="#151515" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.5 7.5C15.5 3.91 12.142 1 8 1C3.858 1 0.5 3.91 0.5 7.5C0.5 11.09 3.858 14 8 14C8.525 14 9.037 13.952 9.532 13.863L13.5 16V11.909C14.738 10.75 15.5 9.204 15.5 7.5Z" stroke="#151515" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_5200_13573">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
      </clipPath>
    </defs>
  </svg>
);
